import firebase from "firebase/app";

import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import removePublisherPrice from "astrid-firestore/src/api/prices/removePublisherPrice";

import ViewAgreementDropdownItem from "../../../../agreements/components/AgreementDropdownMenu/items/ViewAgreementDropdownItem";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function PublisherPriceDropdownMenu({ price, publisher, organization }) {
	const { t } = useTranslation();

	return (
		<DropdownMenu>
			{({ setLoading }) => (
				<>
					<ViewAgreementDropdownItem agreement={price.agreement} />

					<Dropdown.Item
						text={t("remove", "Remove")}
						onClick={async () => {
							setLoading(true);
							await removePublisherPrice(firebase, { publisher, organization, type: price.type });
							setLoading(false);
						}}
					/>
				</>
			)}
		</DropdownMenu>
	);
}
